import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { assert } from '@ember/debug';
import { action } from '@ember/object';
export interface TextareaControlSignature {
    Element: HTMLTextAreaElement;
    Args: {
        isConfirmed?: boolean;
        hasError?: boolean;
        onChange?: (value: string, e: Event | InputEvent) => void;
        value?: string;
        ariaLabel?: string;
    };
}
const STYLES = {
    base: [
        'form-input',
        'text-16',
        'sm:text-14',
        'px-0',
        'py-2',
        'sm:py-0',
        'w-full',
        'bg-transparent',
        'placeholder:text-grey',
        'border-b-grey',
        'border-l-0',
        'border-r-0',
        'border-t-0',
        'focus:border-b-black',
        'focus:ring-0',
        '[&:disabled]:border-b-grey-light',
        '[&:disabled]:text-grey-light',
        '[&:disabled]:placeholder:text-transparent'
    ],
    confirmed: [
        'text-teal',
        'border-b-teal',
        'focus:border-b-teal',
        'focus:shadow-confirmed-input'
    ],
    error: [
        'text-red',
        'border-b-red',
        'focus:border-b-red',
        'focus:shadow-error-input'
    ]
} as const;
export default class WrFormControlsTextareaComponent extends Component<TextareaControlSignature> {
    get styles() {
        let styles1;
        if (this.args.isConfirmed) styles1 = [
            ...STYLES.base,
            ...STYLES.confirmed
        ];
        else if (this.args.hasError) styles1 = [
            ...STYLES.base,
            ...STYLES.error
        ];
        else styles1 = [
            ...STYLES.base,
            'focus:shadow-input'
        ];
        return styles1.join(' ');
    }
    @action
    handleInput(e1: Event | InputEvent): void {
        assert('Expected HTMLTextAreaElement', e1.target instanceof HTMLTextAreaElement);
        this.args.onChange?.(e1.target.value, e1);
    }
    static{
        template(`
    <textarea
      aria-label={{@ariaLabel}}
      class={{this.styles}}
      {{on 'input' this.handleInput}}
      rows='1'
      ...attributes
    >{{@value}}</textarea>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3NlbWVpYS9wYWNrYWdlcy9lbWJlci1hZGRvbnMvdjIvZW1iZXItd2lzZXIvc3JjL2NvbXBvbmVudHMvd3IvZm9ybS9jb250cm9scy90ZXh0YXJlYS5ndHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IENvbXBvbmVudCBmcm9tICdAZ2xpbW1lci9jb21wb25lbnQnO1xuaW1wb3J0IHsgb24gfSBmcm9tICdAZW1iZXIvbW9kaWZpZXInO1xuaW1wb3J0IHsgYXNzZXJ0IH0gZnJvbSAnQGVtYmVyL2RlYnVnJztcbmltcG9ydCB7IGFjdGlvbiB9IGZyb20gJ0BlbWJlci9vYmplY3QnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFRleHRhcmVhQ29udHJvbFNpZ25hdHVyZSB7XG4gIEVsZW1lbnQ6IEhUTUxUZXh0QXJlYUVsZW1lbnQ7XG4gIEFyZ3M6IHtcbiAgICBpc0NvbmZpcm1lZD86IGJvb2xlYW47XG4gICAgaGFzRXJyb3I_OiBib29sZWFuO1xuICAgIG9uQ2hhbmdlPzogKHZhbHVlOiBzdHJpbmcsIGU6IEV2ZW50IHwgSW5wdXRFdmVudCkgPT4gdm9pZDtcbiAgICB2YWx1ZT86IHN0cmluZztcbiAgICBhcmlhTGFiZWw_OiBzdHJpbmc7XG4gIH07XG59XG5cbmNvbnN0IFNUWUxFUyA9IHtcbiAgYmFzZTogW1xuICAgICdmb3JtLWlucHV0JyxcbiAgICAndGV4dC0xNicsXG4gICAgJ3NtOnRleHQtMTQnLFxuICAgICdweC0wJyxcbiAgICAncHktMicsXG4gICAgJ3NtOnB5LTAnLFxuICAgICd3LWZ1bGwnLFxuICAgICdiZy10cmFuc3BhcmVudCcsXG4gICAgJ3BsYWNlaG9sZGVyOnRleHQtZ3JleScsXG4gICAgJ2JvcmRlci1iLWdyZXknLFxuICAgICdib3JkZXItbC0wJyxcbiAgICAnYm9yZGVyLXItMCcsXG4gICAgJ2JvcmRlci10LTAnLFxuICAgICdmb2N1czpib3JkZXItYi1ibGFjaycsXG4gICAgJ2ZvY3VzOnJpbmctMCcsXG4gICAgJ1smOmRpc2FibGVkXTpib3JkZXItYi1ncmV5LWxpZ2h0JyxcbiAgICAnWyY6ZGlzYWJsZWRdOnRleHQtZ3JleS1saWdodCcsXG4gICAgJ1smOmRpc2FibGVkXTpwbGFjZWhvbGRlcjp0ZXh0LXRyYW5zcGFyZW50J1xuICBdLFxuICBjb25maXJtZWQ6IFtcbiAgICAndGV4dC10ZWFsJyxcbiAgICAnYm9yZGVyLWItdGVhbCcsXG4gICAgJ2ZvY3VzOmJvcmRlci1iLXRlYWwnLFxuICAgICdmb2N1czpzaGFkb3ctY29uZmlybWVkLWlucHV0J1xuICBdLFxuICBlcnJvcjogW1xuICAgICd0ZXh0LXJlZCcsXG4gICAgJ2JvcmRlci1iLXJlZCcsXG4gICAgJ2ZvY3VzOmJvcmRlci1iLXJlZCcsXG4gICAgJ2ZvY3VzOnNoYWRvdy1lcnJvci1pbnB1dCdcbiAgXVxufSBhcyBjb25zdDtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgV3JGb3JtQ29udHJvbHNUZXh0YXJlYUNvbXBvbmVudCBleHRlbmRzIENvbXBvbmVudDxUZXh0YXJlYUNvbnRyb2xTaWduYXR1cmU-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